// // src/private-route.tsx

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import authApi from './api/authApi';

export const PrivateRoute: React.FC = () => {
  return authApi.isAuthed() ? <Outlet /> : <Navigate to="/" replace />;
};
